// The main layout holds all the pages on the entire site. Global SCSS and other site-spanning information is handled
// in this component.
import Cookies from '@/components/cookies/component'
import MetaDescription from '@/components/meta-description/component'
import StructuredData from '@/components/structured-data/component'
import CanonicalLink from '@/components/canonical-link/component'
import Backdrop from '@/components/backdrop/component'
import Frames from '@/components/frames/component'

export default {
  name: 'main-layout',
  components: {
    Cookies,
    MetaDescription,
    StructuredData,
    CanonicalLink,
    Backdrop,
    Frames
  },
  computed: {
    backdropIsShowing () {
      return this.$store.getters.backdropIsShowing
    },
    framesDialogIsShowing () {
      return this.$store.getters.framesDialogIsShowing
    },
    frames () {
      const ret = []
      let metadata = this.$store.getters.productsMetadata
      Object.entries(metadata).forEach((item) => {
        if (item[1].type === 'frame') {
          ret.push(item[1])
        }
      })
      return ret
    }
  },
  methods: {
    closeFramesDialog () {
      this.$store.dispatch('showFramesDialog', false)
      this.$store.dispatch('showBackdrop', false)
    },
    seeAllFrames () {
      this.closeFramesDialog()
      this.$router.push({ name: 'frames' })
    },
    goToCheckout () {
      this.closeFramesDialog()
      this.$router.push({ name: 'checkout' })
    }
  },
  watch: {
    // Close the cart if we close the backdrop.
    '$store.getters.backdropIsShowing' () {
      if (!this.$store.getters.backdropIsShowing) {
        this.closeFramesDialog()
      }
    },
    '$store.getters.framesDialogIsShowing' () {
      if (this.$store.getters.framesDialogIsShowing === true) {
        this.$store.dispatch('trackViewFrames', {
          list: 'frames dialog',
          frames: this.frames
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/layouts/main/script.js